import classnames from 'classnames';
import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';
import {
    Collapse,
    Container,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Nav,
    Navbar,
    NavbarBrand,
    NavbarToggler,
    NavItem,
    UncontrolledDropdown
} from 'reactstrap';
import { COMMON_NS } from '@intelingu/core/constants/base.constants';
import { CourseModel } from '@intelingu/core/interfaces/models/CourseModel';
import { lazyInject } from '@intelingu/core/IoC/container';
import { bindRouter } from '@intelingu/core/utils/bindRouter';
import { CourseStore } from '@intelingu/core/stores/CourseStore';
import { UserStore } from '@intelingu/core/stores/UserStore';
import withTranslation from '@intelingu/core/utils/withTranslation';
import {SubscriptionStore} from "@intelingu/core/stores/SubscriptionStore";
import {AppStore} from "../../../stores/AppStore";

export interface ProfileHeaderProps {
    t?;
}

@bindRouter
@withTranslation(COMMON_NS)
@observer export class Header extends Component<ProfileHeaderProps, any> {

    @lazyInject(UserStore) userStore: UserStore;
    @lazyInject(CourseStore) courseStore: CourseStore;
    @lazyInject(AppStore) appStore: AppStore;
    @lazyInject(SubscriptionStore) subscriptionStore: SubscriptionStore;

    @observable isOpen = false;
    @observable isCourseDropdown = false;
    @observable isProfileDropdown = false;

    get boughtCourses() {
        return this.courseStore.coursesList.filter(item => item.is_available);
    }

    get buyCourses() {
        return this.courseStore.coursesList.filter(item => !item.is_available);
    }

    renderCourseItem = (course: CourseModel) => {
        return <>
            <span>{ course.name }</span>
            <img
                src={course.icon}
                alt={course.translation_language}
                width={20}
            />
        </>
    };

    @action.bound toggle() {
        this.isOpen = !this.isOpen;
    }

    @action.bound logout(e) {
        e.preventDefault();

        this.appStore.resetTour();
        this.userStore.logout();
    }

    @action.bound hideNav() {
        this.isOpen = false;
        this.isCourseDropdown = false;
        this.isProfileDropdown = false;
    }

    render() {
        const { t } = this.props;

        if (!this.courseStore.currentCourse) {
            return null;
        }

        return <>
            <Navbar
                className={classnames('profile navbar', { 'opened': this.isOpen })}
                light
                expand="md"
                fixed={'top'}
            >
                <Container>
                    <NavbarBrand href="/">
                        <img
                            src={require('../../../../public/assets/images/logo.svg')}
                            alt={'intelingu'}
                            style={{ position: 'relative', top: -1 }}
                            width={112}
                        />
                    </NavbarBrand>
                    {/*<NavbarToggler onClick={this.toggle} />*/}

                    <button className="menu-wrapper d-md-none" onClick={this.toggle}>
                        <div className={`hamburger-menu ${this.isOpen ? 'animate' : ''}`} />
                    </button>

                    <Collapse isOpen={this.isOpen} navbar>
                        <Nav className="ml-auto" navbar>
                            { /*(!this.subscriptionStore.containsBoughtSubscriptions && this.userStore?.user && this.userStore?.user?.inverted_cards >= 10) && (
                                <NavItem>
                                    <NavLink className={'nav-link pricing-link'} to="/subscriptions">Jetzt Voll-Mitgliedschaft sichern</NavLink>
                                </NavItem>
                            )*/ }
                            <NavItem>
                                <NavLink
                                    className={'nav-link'}
                                    onClick={this.hideNav}
                                    exact
                                    to="/"
                                >{ t('headerHomeLink') }</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className={'nav-link'} to="/help">{ t('headerHelpLink') }</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className={'nav-link'} to="/subscriptions">{ t('headerPricingLink') }</NavLink>
                            </NavItem>
                            {/*<NavItem>
                                <NavLink className={'nav-link'} to="/further">{ t('headerFurtherCourses') }</NavLink>
                            </NavItem>*/}

                            <Dropdown
                                isOpen={this.isCourseDropdown}
                                toggle={() => this.isCourseDropdown = !this.isCourseDropdown}
                                nav
                                inNavbar
                            >
                                <DropdownToggle nav caret>
                                    <span className={'hidden'}>{ t('headerDropdownLearningLanguage') }</span>
                                    <img src={this.courseStore.currentCourse.icon} alt={this.courseStore.currentCourse.source_language} width={22} />
                                </DropdownToggle>
                                <DropdownMenu right>
                                    { this.boughtCourses.length > 0 && (
                                        <>
                                            <h6 className="dropdown-header">{ t('headerDropdownAvailableCourses') }</h6>
                                            { this.boughtCourses.map(course => (
                                                <button
                                                    className={'dropdown-item language'}
                                                    onClick={e => {
                                                        this.courseStore.setCourse(course.id);

                                                        window.location = '/' as any;

                                                        this.hideNav();
                                                    }}
                                                    key={course.id}
                                                >
                                                    { this.renderCourseItem(course) }
                                                </button>
                                            ))}
                                        </>
                                    )}

                                    { this.buyCourses.length > 0 && (
                                        <>
                                            <h6 className="dropdown-header">{ t('headerDropdownBuyCourses') }</h6>
                                            { this.buyCourses.map(course => (
                                                <Link
                                                    to={`/subscriptions/${course.id}`}
                                                    key={course.id}
                                                    onClick={this.hideNav}
                                                    className={'dropdown-item language'}
                                                >{ this.renderCourseItem(course) }</Link>
                                            ))}
                                        </>
                                    )}
                                </DropdownMenu>
                            </Dropdown>

                            <Dropdown
                                isOpen={this.isProfileDropdown}
                                toggle={() => this.isProfileDropdown = !this.isProfileDropdown}
                                nav
                                inNavbar
                            >
                                <DropdownToggle nav caret>
                                    { this.userStore.user.display_name }
                                </DropdownToggle>
                                <DropdownMenu right>
                                    <Link
                                        className={'dropdown-item'}
                                        onClick={this.hideNav}
                                        to="/profile/edit"
                                    >{ t('headerProfile') }</Link>
                                    <a href="" className={'dropdown-item'} onClick={this.logout}>{ t('headerLogout') }</a>
                                </DropdownMenu>
                            </Dropdown>
                        </Nav>
                    </Collapse>
                </Container>
            </Navbar>
        </>
    }

}
